import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert, AlertTitle } from '@mui/material';
export const Toast = ({ open, title, text, severity, onClose, autoHideDuration = 1000, ...props }) => {
    return (React.createElement(Snackbar, { onClose: onClose, open: open, autoHideDuration: autoHideDuration, anchorOrigin: { vertical: 'top', horizontal: 'right' }, ...props },
        React.createElement(Alert, { elevation: 6, variant: "filled", onClose: onClose, severity: severity, sx: { width: '100%' } },
            title && React.createElement(AlertTitle, null, title),
            text)));
};
